import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MyProfilePopupService } from '@src/app/modules/my-profile/my-profile-popup.service';
import { MyProfileService } from '@src/app/modules/my-profile/my-profile.service';
import { CommonService } from '@src/app/services/common.service';
import { UserService } from '@src/app/services/user.service';
import { SharedModule } from '@src/app/shared/shared.module';
import { AddressProfile } from '@src/app/shared/types/address.type';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { NzTabsModule } from 'ng-zorro-antd/tabs';

@Component({
    selector: 'app-address-badges',
    standalone: true,
    imports: [CommonModule, NzTabsModule, NzSkeletonModule, SharedModule],
    templateUrl: './address-badges.component.html',
    styleUrls: ['./address-badges.component.less'],
})
export class AddressBadgesComponent implements OnInit {
    @Input() walletAddress: string;
    @Input() pageType: 'address' | 'profile' = 'address';
    @Input() walletProfile: AddressProfile;

    get myBadges() {
        return this.myProfileService.badges$.getValue()?.filter(badge => badge.earned_at);
    }

    get badges() {
        if (this.pageType === 'address') {
            return this.walletProfile?.badges?.filter(badge => badge.is_earned);
        }
        return this.myBadges;
    }

    constructor(
        public myProfileService: MyProfileService,
        public myProfilePopup: MyProfilePopupService,
        public commonService: CommonService,
        public userService: UserService
    ) {}

    ngOnInit() {
        this.myProfileService.getAllBadges();
    }

    showAll() {
        this.myProfilePopup.showAllBadges();
    }
}
